import * as React from 'react';
import * as classnames from 'classnames';
import Select from 'react-select';
import { Project } from '@nexxt/common/types';
import IndicatorsContainer from '../../common/reactSelect/IndicatorsContainer';
import MediaManager from '../../libraries/mediaLibrary/MediaManager';
import { UilPen } from '@iconscout/react-unicons';
import { INCA_LOGO_URL } from '@nexxt/common/constants';

interface AddClientProps {
    clientList: any[];
    project: Project;
    isAddClientOpen: boolean;
    client: any;
    errorObject: any;
    editEnabled: boolean;
    clientTerm: 'Client' | 'Team/Program';
    updateClient: (client) => void;
    setProjectValue: (keyName: string, value: any) => void;
    toggleAddClient: () => void;
    createClient: (values: any, clientURL: string) => Promise<void>;
    disableInputByFieldName: (keyName: string) => boolean;
}
const AddClient: React.FC<AddClientProps> = ({
    clientList,
    project,
    isAddClientOpen,
    client,
    errorObject,
    editEnabled,
    clientTerm,
    updateClient,
    setProjectValue,
    toggleAddClient,
    createClient,
    disableInputByFieldName
}: AddClientProps) => {
    const [showMediaManager, setShowMediaManager] = React.useState(false);
    const newClientResponse = [
        { label: `Add ${clientTerm}`, value: '' },
        ...clientList
    ];
    return (
        <React.Fragment>
            {clientList && (
                <React.Fragment>
                    <label className="form-group__label form-group__label--block w-full flex justify-between">
                        <span>{clientTerm}</span>
                        <span
                            className="text-blue cursor-pointer font-semibold"
                            onClick={toggleAddClient}
                        >
                            Add {clientTerm}
                        </span>
                    </label>
                    <Select
                        className="react-select"
                        classNamePrefix="react-select"
                        isDisabled={disableInputByFieldName('client')}
                        value={project.client}
                        options={newClientResponse}
                        onChange={(selectedClient) => {
                            if (selectedClient.label === `Add ${clientTerm}`) {
                                toggleAddClient();
                            } else {
                                setProjectValue('client', selectedClient);
                            }
                        }}
                        placeholder={`Select ${clientTerm}`}
                        components={{
                            IndicatorsContainer
                        }}
                        required
                    />
                    {!disableInputByFieldName('add_client') && isAddClientOpen && (
                        <div className="row">
                            <React.Fragment>
                                <div className="form col-md-12">
                                    <fieldset className="inner-form">
                                        <div className="inner-form__title cursor-pointer">
                                            <i className="nx nx-add"></i> Add{' '}
                                            {clientTerm}
                                        </div>
                                        <div className="box-wrapper">
                                            <div className="box-actions">
                                                <div
                                                    className="box-actions--item"
                                                    onClick={toggleAddClient}
                                                >
                                                    <i className="nx nx-close"></i>
                                                </div>
                                                <button
                                                    onClick={() =>
                                                        createClient(
                                                            client,
                                                            client.clientURL
                                                        )
                                                    }
                                                    type="button"
                                                    className="box-actions--item box-actions--item-green"
                                                >
                                                    <i className="nx nx-check"></i>
                                                </button>
                                            </div>
                                            <React.Fragment>
                                                <div className="row">
                                                    <div
                                                        className={classnames(
                                                            'form-group form-group--inline-block col-md-6',
                                                            {
                                                                error: ''
                                                            }
                                                        )}
                                                    >
                                                        <label className="form-group__label from-group--block">
                                                            {clientTerm}
                                                        </label>
                                                        <input
                                                            className="form-group__control"
                                                            type="text"
                                                            name={'clientName'}
                                                            value={
                                                                client?.clientName
                                                            }
                                                            onChange={(e) =>
                                                                updateClient({
                                                                    ...client,
                                                                    clientName:
                                                                        e.target
                                                                            .value
                                                                })
                                                            }
                                                            placeholder={`${clientTerm} name`}
                                                            disabled={
                                                                !editEnabled
                                                            }
                                                        />
                                                        {errorObject?.clientName && (
                                                            <span className="form-group__error-msg">
                                                                {
                                                                    errorObject.clientName
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="form-group col-md-12">
                                                        <label className="form-group__label form-group__label--block">
                                                            {clientTerm}
                                                            Logos
                                                        </label>
                                                        <span
                                                            className="form-group__icon"
                                                            onClick={() =>
                                                                setShowMediaManager(
                                                                    true
                                                                )
                                                            }
                                                        >
                                                            <MediaManager
                                                                showMediaManager={
                                                                    showMediaManager
                                                                }
                                                                toggleMediaManager={(
                                                                    value
                                                                ) =>
                                                                    setShowMediaManager(
                                                                        value
                                                                    )
                                                                }
                                                                showMediaLibrary
                                                                applyCurrentMedia={({
                                                                    mediaURL
                                                                }) =>
                                                                    updateClient(
                                                                        {
                                                                            ...client,
                                                                            clientURL:
                                                                                mediaURL
                                                                        }
                                                                    )
                                                                }
                                                            >
                                                                <div>
                                                                    <img
                                                                        src={
                                                                            client?.clientURL
                                                                                ? client?.clientURL
                                                                                : INCA_LOGO_URL
                                                                        }
                                                                    />
                                                                    <div
                                                                        className="hover-container"
                                                                        onClick={() =>
                                                                            setShowMediaManager(
                                                                                true
                                                                            )
                                                                        }
                                                                    >
                                                                        <div className="hover-container--item">
                                                                            <UilPen
                                                                                size={
                                                                                    16
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </MediaManager>
                                                        </span>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        </div>
                                    </fieldset>
                                </div>
                            </React.Fragment>
                        </div>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default AddClient;
